export const normalizeEmptyToNull = (value: any): any => {
  if (value === "") return null;

  if (Array.isArray(value)) {
    return value.map((item) => normalizeEmptyToNull(item));
  }

  if (value !== null && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([key, val]) => [key, normalizeEmptyToNull(val)])
    );
  }

  return value;
};
